import { fractionEquals, fractionFuzzyEquals } from './fractions';
import type { Numeric } from './types';
import { asFraction } from './types';

const DEFAULT_PRECISION = 10;

/**
 * Fuzzy equality for numbers or fractions.
 */
export function fuzzyEquals(
  v1: Numeric,
  v2: Numeric,
  precision = DEFAULT_PRECISION,
): boolean {
  return fractionFuzzyEquals(asFraction(v1), asFraction(v2), precision);
}

/**
 * Exact equality for numbers or fractions.
 */
export function equals(v1: Numeric, v2: Numeric): boolean {
  return fractionEquals(asFraction(v1), asFraction(v2));
}

/**
 * Returns true if val equals any value in arr.
 */
export function equalsIn(val: Numeric, arr: Numeric[]): boolean {
  for (const item of arr) {
    if (equals(val, item)) return true;
  }
  return false;
}
